import React from 'react';

import Modal from 'react-bootstrap/lib/Modal';
import ServiceConfigurator from './ServiceConfigurator';
import AddServiceButton from './AddServiceButton';

function getInitialState(props) {
    let chosenConfigurations = {};
    props.serviceSectionPartConfigs.map(configuration => {
        chosenConfigurations[configuration.id] = {partIds: []};
    });

    return {
        quantity: 1,
        chosenConfigurations: chosenConfigurations,
        specialInstruction: "",
        activePanelIndex: 0
    }
}

export default class AddServiceModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = getInitialState(props);
    }

    addToCart = () => {
        const firstInvalidConfiguration = this.invalidServiceConfigurations()[0]

        if (!!firstInvalidConfiguration) {
            const firstInvalidPanelIndex = this.props.serviceSectionPartConfigs.findIndex(config => config.id === firstInvalidConfiguration.id)
            this.setState({ activePanelIndex: firstInvalidPanelIndex})
            return false
        }

        let alertTime;
        let chosenParts = [];

        if (this.props.service.launch_available && !this.props.service.dinner_available) {
            alertTime = I18n.t('service_ordering.only_lunch_alert');
        } else if (!this.props.service.launch_available && this.props.service.dinner_available) {
            alertTime = I18n.t('service_ordering.only_dinner_alert');
        }

        if (alertTime && (confirm(alertTime) !== true)) {
            return false;
        }

        this.props.serviceSectionPartConfigs.map(configuration => {
            configuration.service_part_options.map(part => {
                if (this.state.chosenConfigurations[configuration.id].partIds.indexOf(part.id) !== -1) {
                    chosenParts.push({id: part.id, name: part.name, price: part.price_cents});
                }
            });
        });

        this.props.addToCart(chosenParts, this.state.quantity, this.getSpecialInstructions());
        this.props.onHide();
    }

    decreaseQuantity = (event) => {
        event.preventDefault();

        if (this.state.quantity > 1) {
            this.setState({quantity: this.state.quantity - 1});
        }
    }

    increaseQuantity = (event) => {
        event.preventDefault();

        this.setState({quantity: this.state.quantity + 1});
    }

    handleSelectedPartsChanged = (configurationId, selectedPartIds) => {
        let configurations = this.state.chosenConfigurations;
        configurations[configurationId].partIds = selectedPartIds;

        this.setState({chosenConfigurations: configurations});
    }

    getSpecialInstructions() {
        return this.state.specialInstruction;
    }

    invalidServiceConfigurations = () => {
      const configurations = this.state.chosenConfigurations;
      const invalidConfigurations = []

      for (let i = 0; i < this.props.serviceSectionPartConfigs.length; i++) {
        const config = this.props.serviceSectionPartConfigs[i];

        if (config.min > configurations[config.id].partIds.length) {
          invalidConfigurations.push(config);
        }
      }

      return invalidConfigurations
    }

    handleSpecialInstructionChanged = (event) => {
        this.setState({ specialInstruction: event.target.value });
    }

    render() {
        let image, additionalParts;

        if (this.props.service) {
            image = this.props.service.image_url ?
                <div className="service-image" style={{backgroundImage: `url(${this.props.service.image_url}`}} /> : '';
        }

        /*
         var alertTime;
         if (this.props.service.launch_available && !this.props.service.dinner_available) {
         alertTime = <div className="alert alert-warning service-time-alert">Attenzione! Questo piatto è disponibile solo a pranzo, se scegli la consegna per la cena il tuo ordine potrebbe venire rifiutato dal ristorante.</div>;
         } else if (!this.props.service.launch_available && this.props.service.dinner_available) {
         alertTime = <div className="alert alert-warning service-time-alert">Attenzione! Questo piatto è disponibile solo a cena, se scegli la consegna per il pranzo il tuo ordine potrebbe venire rifiutato dal ristorante.</div>;
         }
         */

        if (this.props.serviceSectionPartConfigs && this.props.serviceSectionPartConfigs.length > 0) {
            additionalParts =
                <div>
                    <label style={{ "marginTop": "10px" }}>{I18n.t('service_ordering.add_service_modal.choose_ingredients')}</label>
                    <div className="service-parts-list">
                        <ServiceConfigurator serviceSectionPartConfigs={this.props.serviceSectionPartConfigs}
                                             activePanelIndex={this.state.activePanelIndex}
                                             onPanelClick={(index) => this.setState({activePanelIndex: index}) }
                                             onSelectedPartsChanged={this.handleSelectedPartsChanged}/>
                    </div>
                </div>
        }

        const invalidConfigurations = this.invalidServiceConfigurations()
        const addButtonEnabled = invalidConfigurations.length === 0

        return (
            <Modal show={this.props.show}
                   onHide={this.props.onHide}
                   onExited={this.props.onExited}
                   className="modal modal--full-height add-service-modal"
                   animation={true}>
                <Modal.Header>
                    <div>{this.props.service.name}</div>
                    <button
                        className="close"
                        aria-label="Close"
                        data-dismiss="modal"
                        type="button"
                        onClick={this.props.onHide}
                        >
                            <i className="fal fa-times" />
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <div className="service-image-container">
                        {image}
                    </div>

                    <p className="description">{this.props.service.description}</p>

                    {additionalParts}

                    <label style={{ "marginTop": "10px" }}>{I18n.t(`service_ordering.add_service_modal.${this.props.venueType}.special_instructions_label`)}</label>

                    <div className="special-instructions">
                        <textarea placeholder={I18n.t(`service_ordering.add_service_modal.${this.props.venueType}.special_instructions_input_placeholder`)}
                                  value={this.state.specialInstruction}
                                  onChange={this.handleSpecialInstructionChanged} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="change-quantity-box">
                        <a href="#" className="button decrease" title={I18n.t('service_ordering.decrease_quantity')}
                           onClick={this.decreaseQuantity}>
                            <span className="fal fa-minus icon"/>
                        </a>
                        <span className="quantity">{this.state.quantity}</span>
                        <a href="#" className="button increase" title={I18n.t('service_ordering.increase_quantity')}
                           onClick={this.increaseQuantity}>
                            <span className="fal fa-plus icon"/>
                        </a>
                    </div>
                    <AddServiceButton enabled={addButtonEnabled}
                                      missingConfigs={invalidConfigurations.map(config => config.name)}
                                      onClick={this.addToCart}/>
                </Modal.Footer>
            </Modal>
        );
    }
}
